// FormAutoComplete Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import classnames from 'classnames'
import validator from 'validator'
import _ from 'lodash'

import Input from '../input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class FormAutoComplete extends Component {
  static get propTypes () {
    return {
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      displayValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      name: PropTypes.string,
      onChange: PropTypes.func,
      onSelect: PropTypes.func,
      options: PropTypes.array,
      multilingual: PropTypes.bool,
      addLabel: PropTypes.string,
      addName: PropTypes.string,
      addValue: PropTypes.string,
      onAddChange: PropTypes.func,
      bShowButton: PropTypes.bool,
      className: PropTypes.string,
      validations: PropTypes.array,
      onBlur: PropTypes.func,
      onKeyDown: PropTypes.func,
      autoFocus: PropTypes.bool,
      styleDotted: PropTypes.bool,
      onToggleAdd: PropTypes.func,
      hideAdd: PropTypes.bool,
      selectValue: PropTypes.bool,
      showAdd: PropTypes.bool,
      showOptionIcon: PropTypes.bool,
      keywordLength: PropTypes.number,
      errorLabel: PropTypes.string,
      errorMessage: PropTypes.string,
      showSelection: PropTypes.bool,
      hasAutoSelect: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      value: '',
      displayValue: '',
      label: '',
      name: '',
      onChange: null,
      onSelect: null,
      options: [],
      multilingual: true,
      addLabel: '',
      addName: '',
      onAddChange: null,
      bShowButton: true,
      className: '',
      validations: [],
      addValue: '',
      onBlur: null,
      onKeyDown: null,
      autoFocus: false,
      styleDotted: false,
      onToggleAdd: null,
      hideAdd: false,
      selectValue: false,
      showAdd: false,
      showOptionIcon: false,
      keywordLength: 1,
      errorLabel: '',
      errorMessage: '',
      showSelection: false,
      hasAutoSelect: false
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      showSelection: false,
      dataDate: null,
      showAdd: !!props.showAdd,
      value: props.displayValue,
      error: false,
      focusedIndex: -1
    }

    this._blurTime = null
    this._activeClickedElement = ''
    this._bInputChanged = false

    this._references = {}
    this._createBaseReferences(this._references)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this.setState({ value: nextProps.displayValue })
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)

    if (this.props.autoFocus && this._references.refInput.current) {
      this.focus()
    }
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  validate () {
    const validations = this.props.validations
    if (validations !== undefined && validations.length > 0) {
      for (let i = 0; i < validations.length; i++) {
        if (!this._validateField(validations[i])) {
          this.setState({ error: true })
          return false
        }
      }
    }

    return true
  }

  getValue () {
    return this.state.value
  }

  hideAdd () {
    this.setState({ showSelection: true, showAdd: false })
  }

  hideAddAndSelection () {
    this.setState({ showSelection: false, showAdd: false })
  }

  render () {
    return (
      <div className='form-autocomplete' ref={this._references.select}>
        <div className='form-autocomplete-field'>{this._renderField()}</div>

        {this.props.showOptionIcon
          ? this._showDropdown()
          : this._renderOptions()}
      </div>
    )
  }

  /* Private functions */
  _createBaseReferences (references) {
    references.refInput = React.createRef()
    references.select = React.createRef()
    references.selectDrop = React.createRef()
  }

  _renderObjectItems () {
    this.props.options.map(option => {
      option.labelHasHtml = option.labelHasHtml ? option.labelHasHtml : false
    })
    return this.props.options.map((opt, idx) => (
      <div
        className={classnames('option-item', {
          archived: opt.bArchived,
          focused: this.state.focusedIndex === idx
        })}
        key={idx}
        onClick={!opt.bArchived ? this._handleSelect.bind(this, opt) : null}
      >
        {this._renderOptionLabel(opt)}
        {opt.bArchived && (
          <span className='itemsubtitle'>
            <IntlMessage ident='common.form.archived' />
          </span>
        )}
      </div>
    ))
  }

  _renderOptionLabel (opt) {
    if (!opt.labelHasHtml) {
      return <span>{opt.label}</span>
    }

    return <div dangerouslySetInnerHTML={{ __html: opt.label }} />
  }

  _renderOptions () {
    if (this.state.showAdd || !this.state.showSelection) {
      return ''
    }

    const keywordLen = this.props.displayValue
      ? this.props.displayValue.length
      : 0
    if (
      this.state.showSelection &&
      this.props.options.length > 0 &&
      keywordLen >= this.props.keywordLength
    ) {
      return (
        <div className='autocomplete-options' ref={this._references.selectDrop}>
          {this._renderObjectItems()}
        </div>
      )
    } else if (
      keywordLen < this.props.keywordLength ||
      (this.props.options.length < 1 &&
        this.props.displayValue === this.props.value)
    ) {
      return ''
    }

    let showButton = ''
    if (this.props.bShowButton) {
      showButton = (
        <IconButton
          type='primary'
          size='big'
          icon='autocomplete-add'
          title='common.list.titleAdd'
          canHover={false}
          className='wizard-client-add'
          onClick={this._handleAddClick.bind(this)}
        />
      )
    }

    const _class = classnames(
      'autocomplete-message',
      {},
      `autocomplete-message_${this.props.className}`
    )

    const errorMsg = IntlUtil.convertMessage('common.list.autocompleteError')
    let msgTitle = `${errorMsg}`
    if (this.props.errorLabel) {
      msgTitle = <IntlMessage ident={this.props.errorLabel} />
    }

    let msgText = (
      <p>
        <IntlMessage ident='common.list.autoCompleteCreateTitle' />
        <IntlMessage ident='common.list.autoCompleteClick' />
        <i className='icon icon-autocomplete-plus' />
        <IntlMessage ident='common.list.autoCompleteButton' />
      </p>
    )

    if (this.props.errorMessage) {
      msgText = (
        <p>
          <IntlMessage ident={this.props.errorMessage} />
          <i className='icon icon-autocomplete-plus' />
          <IntlMessage ident='common.list.autoCompleteButton' />
        </p>
      )
    }

    if (!this.props.hideAdd) {
      return (
        <div className={_class} ref={this._references.selectDrop}>
          {showButton}
          <h2>{msgTitle}</h2>
          {msgText}
        </div>
      )
    } else {
      return ''
    }
  }

  _renderField () {
    const { autoFocus } = this.props

    if (this.state.showAdd) {
      const _className = classnames(
        'form-group',
        {
          has_error: this.state.error
        },
        this.props.className
      )

      return (
        <div className={_className}>
          <Input
            ref={this._references.refInput}
            type='text'
            name={this.props.addName}
            label={this.props.addLabel}
            value={this.props.addValue}
            size={10}
            maxLength={100}
            className='project-clientadd'
            styleDotted={this.props.styleDotted}
            onChange={this.props.onAddChange}
          />
          <IconButton
            icon='header-close'
            size='normal'
            canHover={false}
            className='wizard-client-cancel'
            tooltip='common.list.tipCancel'
            tooltipPosition='top'
            onClick={this._handleCancelClick.bind(this)}
          />
        </div>
      )
    }

    const _className = classnames(
      'form-group',
      {
        has_error: this.state.error
      },
      this.props.className
    )
    return (
      <div className={_className}>
        <Input
          ref={this._references.refInput}
          type='text'
          name={this.props.name}
          label={this.props.label}
          value={this.props.displayValue}
          size={10}
          maxLength={100}
          prefixIcon='form-search'
          onChange={this._onChange.bind(this)}
          onBlur={this._handleBlur.bind(this)}
          onKeyDown={this._onKeyDown.bind(this)}
          autoFocus={autoFocus}
          onFocus={
            this.props.selectValue
              ? this._handleSelectFocus.bind(this)
              : this._handleFocus.bind(this)
          }
        />
        {this.props.showOptionIcon && this.props.options.length > 0 && (
          <IconButton
            icon='phase-ratecard-available'
            size='normal'
            canHover={false}
            className='phase-ratecard'
            onClick={this._onClickOptionIcon.bind(this)}
          />
        )}
      </div>
    )
  }

  _showDropdown () {
    if (
      this.state.showSelection &&
      this.props.options.length > 0 &&
      this.state.showOptions
    ) {
      return (
        <div className='autocomplete-options' ref={this._references.selectDrop}>
          {this._renderObjectItems()}
        </div>
      )
    } else if (
      this.props.options.length < 1 &&
      this.props.displayValue === this.props.value
    ) {
      return ''
    }

    return ''
  }

  /* Event handlers */
  _handleFocus () {
    this.setState({ showSelection: true })
  }

  _onKeyDown (ev) {
    let { focusedIndex } = this.state
    const { options } = this.props
    const keyCode = ev.keyCode || 0

    if (keyCode === 40 || keyCode === 38) {
      const incr = keyCode === 40 ? 1 : -1
      focusedIndex = this._getNextFocus(options, focusedIndex, incr)

      this.setState({ focusedIndex })
    } else if (keyCode === 13) {
      ev.preventDefault()
      ev.stopPropagation()

      if (focusedIndex !== -1) {
        this._handleSelect(options[focusedIndex], ev)

        ev.target.blur()
      }
    } else if (this.props.onKeyDown) {
      this.props.onKeyDown(ev)
    }
  }

  _getNextFocus (options, focusedIndex, incr) {
    const totalOptions = options.length
    let idx = 0

    while (idx < totalOptions) {
      focusedIndex += incr

      if (focusedIndex < 0) {
        focusedIndex = totalOptions - 1
      } else if (focusedIndex === totalOptions) {
        focusedIndex = 0
      }

      if (options[focusedIndex] && !options[focusedIndex].bArchived) {
        return focusedIndex
      }

      idx++
    }

    return -1
  }

  _handleSelectFocus (ev) {
    ev.preventDefault()
    ev.target.select()

    this.setState({ showSelection: true })
  }

  _handleAddClick (e) {
    e.preventDefault()
    this.setState({ showSelection: false, showAdd: true })

    if (this.props.onToggleAdd) {
      this.props.onToggleAdd(true)
    }
  }

  _handleCancelClick (e) {
    e.preventDefault()
    this.setState({ showSelection: true, showAdd: false })

    if (this.props.onToggleAdd) {
      this.props.onToggleAdd(false)
    }
  }

  _handleSelect (opt, e) {
    e.preventDefault()
    this.setState({ showSelection: false, value: opt.label, focusedIndex: -1 })

    if (this.props.onSelect) {
      this.props.onSelect(opt, e)
    }
  }

  _handleBlur (ev) {
    ev.preventDefault()

    // If input is not changed, no need to do auto select
    if (
      this._bInputChanged &&
      this.props.hasAutoSelect &&
      this.props.displayValue
    ) {
      const searchRes = _.find(
        this.props.options,
        option => option.label === this.props.displayValue
      )
      if (this.props.onSelect) {
        this.props.onSelect(searchRes ? _.cloneDeep(searchRes) : null)
      }
    }

    this._bInputChanged = false

    if (this.props.onBlur) {
      if (this.props.showOptionIcon) {
        if (this._blurTime) {
          window.clearTimeout(this._blurTime)
          this._blurTime = null
        }

        this._blurTime = window.setTimeout(() => {
          this.props.onBlur(ev, this._activeClickedElement === 'showoptions')

          this._activeClickedElement = ''
        }, 500)
      }
      if (!this.state.showSelection || !this.props.showSelection) {
        this.props.onBlur(ev, false)
      }
    }
  }

  _handleDocumentClick = evt => {
    if (
      (this.state.showSelection || this.state.showAdd) &&
      this._references.select.current &&
      this._references.selectDrop.current
    ) {
      const area = ReactDom.findDOMNode(this._references.select.current)
      const dropArea = ReactDom.findDOMNode(this._references.selectDrop.current)

      if (!area.contains(evt.target) && !dropArea.contains(evt.target)) {
        if (this.state.showSelection) {
          this.setState({ showSelection: false })
        } else {
          this.setState({ showAdd: false })
        }
      }
    }
  }

  _validateField (validType) {
    const val = this.getValue()

    switch (validType) {
      case 'required':
        return !validator.isEmpty(val)
      default:
        return true
    }
  }

  _onClickOptionIcon (ev) {
    ev.preventDefault()

    this._activeClickedElement = 'showoptions'
    this.setState({ showOptions: true })
  }

  _onChange (val, ev) {
    this.setState({ focusedIndex: -1 })

    if (this.props.displayValue !== val && this.props.onChange) {
      this._bInputChanged = true
      this.props.onChange(val, ev)
    }
  }

  /* Public Functions */
  showError () {
    this.setState({ error: true })
  }

  clearError () {
    this.setState({ error: false })

    return this.state.error
  }

  focus () {
    if (this._references.refInput.current) {
      this._references.refInput.current.focus()
    }
  }
}

export default FormAutoComplete
